import { graphql } from "@/config/graphql";

export const productionResourcesQuery = graphql(`
  query productionResources($params: ReportParams!) {
    report(params: $params) {
      id
      plant {
        id
        productionResources {
          id
          name
        }
      }
    }
    destinationOptions {
      id
      name
      type
      code
    }
  }
`);
export const addProductionDetailMutation = graphql(`
  mutation addProductionDetail($params: AddProductionDetailParams!) {
    addProductionDetail(params: $params) {
      id
      productionDetails {
        id
        sellQuantity
        destination {
          id
          name
          code
          type
        }
      }
    }
  }
`);
export const updateProductionDetailMutation = graphql(`
  mutation updateProductionDetail($params: UpdateProductionDetailParams!) {
    updateProductionDetail(params: $params) {
      id
      productionDetails {
        id
        sellQuantity
        destination {
          id
          name
          code
          type
        }
      }
    }
  }
`);
export const removeProductionDetailMutation = graphql(`
  mutation removeProductionDetail($params: RemoveProductionDetailParams!) {
    removeProductionDetail(params: $params) {
      id
      productionDetails {
        id
        sellQuantity
        destination {
          id
          name
          code
          type
        }
      }
    }
  }
`);
